export const LeavesShimmer = ({ listLength = 0 }: { listLength?: number }) => {
  return (
    <div className="mt-9 animate-pulse">
      <div className="flex items-center gap-1 mb-3">
        <div className="h-4 w-32 bg-gray-200 dark:bg-gray-700 rounded" />
        <div className="h-4 w-5 bg-gray-200 dark:bg-gray-700 rounded-sm" />
      </div>

      <div className="flex flex-col gap-3">
        {Array.from({ length: listLength }).map((_, index) => (
          <div
            key={index}
            className="w-max flex items-center py-[9px] px-3 border border-border-gray dark:border-border-gray-dk rounded-lg"
          >
            <div className="w-4.5 h-4.5 bg-gray-200 dark:bg-gray-700 rounded" />

            <div className="h-4 w-48 bg-gray-200 dark:bg-gray-700 rounded ml-1" />

            <div className="w-6 h-[1px] mx-1.5 bg-border-gray dark:bg-border-gray-dk" />

            <div className="h-3 w-12 bg-gray-200 dark:bg-gray-700 rounded mr-6" />

            <div className="w-[26px] h-[26px] bg-gray-200 dark:bg-gray-700 rounded-md" />
          </div>
        ))}
      </div>
    </div>
  );
};
